import * as Sentry from "@sentry/react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "./pages/Login";
import ClientSelection from "./pages/ClientSelection";
import Configuration from "./pages/Configuration";
import History from "./pages/History";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <Sentry.ErrorBoundary
    fallback={({ error, resetError }) => (
      <div className="flex min-h-screen items-center justify-center bg-background px-6">
        <div className="space-y-4 text-center">
          <h1 className="text-2xl font-semibold text-destructive">Une erreur s'est produite</h1>
          <p className="text-muted-foreground">{error.message}</p>
          <button
            onClick={resetError}
            className="rounded-md bg-primary px-4 py-2 text-primary-foreground hover:bg-primary/90"
          >
            Réessayer
          </button>
        </div>
      </div>
    )}
    showDialog={false}
  >
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <AuthProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <Routes>
              <Route path="/" element={<Login />} />
              <Route 
                path="/client-selection" 
                element={
                  <ProtectedRoute>
                    <ClientSelection />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/configuration" 
                element={
                  <ProtectedRoute>
                    <Configuration />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/historique" 
                element={
                  <ProtectedRoute>
                    <History />
                  </ProtectedRoute>
                } 
              />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </TooltipProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </Sentry.ErrorBoundary>
);

export default App;
